module.exports = Em.Handlebars.compile("{{view.option.label}}");